import { RcFile } from 'antd/es/upload';

export function validateJsonFileContent(file: RcFile){
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        if(e.target?.result){
          typeof e.target.result === "string" ? JSON.parse(e.target.result) : Buffer.from(e.target.result).toJSON()
        }
        resolve(true);
      } catch {
        resolve(false);
      }
    };
    reader.readAsText(file);
  });
}
